module.exports = __webpack_public_path__ + "static/media/biology.cac9e31f.jpg";